import { translateFunc } from "../common/Filters"
import { countriesWithTwoDigitCode, subscriptionTierValues } from "./Constant"

export const storeDataInStorage = (token, authlevel) => {
  localStorage.setItem("userToken", token);
  localStorage.setItem("authLevel", authlevel);

  sessionStorage.setItem("userToken", token);
  sessionStorage.setItem("authLevel", authlevel);
  sessionStorage.removeItem("userData");
}

export const storeDataInSessionStorage = (token, authlevel) => {
  sessionStorage.setItem("userToken", token);
  sessionStorage.setItem("authLevel", authlevel);
  // Login-as opens a new tab that clones the admin sessionStorage; drop
  // stale profile so settings fetch the impersonated user's data.
  sessionStorage.removeItem("userData");
}

export const storeDataInSessionStorageFromLocalStorage = () => {
  sessionStorage.setItem("userToken", localStorage.userToken);
  sessionStorage.setItem("authLevel", localStorage.authLevel);
}

export const checkLoggedinUser = () => {
  if(sessionStorage.userToken && sessionStorage.authLevel === "1"){
    return true
  } else if(localStorage.userToken && localStorage.authLevel === "1"){
    storeDataInSessionStorageFromLocalStorage();
    return true
  } else {
    return false
  }
}

export const checkLoggedinDealer = () => {
  if(sessionStorage.userToken && (sessionStorage.authLevel === "3" || sessionStorage.authLevel === "0")){
    return true;
  } else if( localStorage.userToken && (localStorage.authLevel === "3" || localStorage.authLevel === "0")) {
    storeDataInSessionStorageFromLocalStorage();
    return true
  } else {
    return false
  }
}

export const getTextBasedOnRoles = (user) => {
  switch (user.authlevel) {
    case "0":
      return translateFunc("lng_dealer_txt");
    case "1":
      return translateFunc("lng_user_txt");
    // case "2":
    //   return translateFunc("lng_multiuser_txt");
    case "3":
      return translateFunc("lng_admin_txt");
    default:
      return "";
  }
}

export const getCountryByPhone = (phone) => {
  let code = phone.slice(0,2);
  let index = countriesWithTwoDigitCode.findIndex(item => ("+" + code) === item.dial_code);
  return index !== -1 ? phone.slice(2, phone.length) : phone;
}

/** Display order: address1, address2, zip, city, country */
export const formatAddress = (item) => {
  if (!item) return "";
  return [item.address1, item.address2, item.zip, item.city, item.country]
    .map((part) => (part == null ? "" : String(part).trim()))
    .filter(Boolean)
    .join(", ");
};

/** Localized label for subscription tier API code (0–9). */
export const formatSubscriptionTierLabel = (value) => {
  const key = subscriptionTierValues.find(
    (t) => t.value === String(value).trim()
  );

  if (key) return translateFunc(key.name);
  const raw = value === null || value === undefined ? "" : String(value);
  return raw;
};

/** Localized label for contract tier (0 = No, 1 = Yes). */ 
export const formatContractTierLabel = (value) => { 
  const normalized = String(value).trim(); 

  if (normalized === "0") return translateFunc("lng_no_txt"); 
  if (normalized === "1") return translateFunc("lng_yes_txt"); 

  return "";
};
